<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="站点类型" class="EL-Form-Item">
                         <el-input placeholder="请输入" v-model="mainSearch.lrType" clearable="clearable"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="站点编号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="mainSearch.lrCode" clearable="clearable"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="状态" class="EL-Form-Item">
                        <el-select v-model="mainSearch.occupyFlag" clearable="clearable">
                            <el-option label="占用" value="1"></el-option>
                            <el-option label="空闲" value="0"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :lg="9" :xl="9">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getSysLineRouter()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetData()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
            </el-form>
            <el-divider></el-divider>
            <plabel text="产线站点">
                <el-button v-authority="'BACK_MENU5_M12_B1'" class="btn-t-edit" @click="(add_or_edit = true), (editBoxShow = true)">新增</el-button>
                <el-button v-authority="'BACK_MENU5_M12_B4'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <!-- 展示 -->
            <h-table :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getSysLineRouter" :data="mainData.data" pagination :nowPage.sync="mainData.nowPage" :pageSize.sync="mainData.pageSize" :total.sync="mainData.total">
                <el-table-column prop="lrCode" label="站点编号" />
                <el-table-column prop="lrName" label="站点名称" />
                <!-- <el-table-column prop="lrRealCode" label="实际站点编号" /> -->
                 <el-table-column prop="lrAgvCode" label="对应AGV编号" />
                 <el-table-column prop="lrType" label="站点类型"/>
                <el-table-column prop="occupyFlag" label="状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.occupyFlag == true">占用</span>
                        <span v-if="scope.row.occupyFlag == false">空闲</span>
                    </template>    
                </el-table-column>
                <el-table-column prop="lineCode" label="产线编号"/>
                <el-table-column prop="lrPointType" label="仓库类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.lrPointType == '10'">装配</span>
                        <span v-if="scope.row.lrPointType == '20'">外圈</span>
                        <span v-if="scope.row.lrPointType == '30'">内圈</span>
                    </template>    
                </el-table-column>
                <el-table-column prop="lrStorage" label="库位信息" />
                <el-table-column prop="lrCtnrTyp" label="容器类型" />
                <el-table-column prop="createTime" label="创建时间" />
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button v-authority="'BACK_MENU5_M12_B2'" size="mini" type="primary" @click="updateRow(scope.row)" plain icon="el-icon-edit-outline" />
                        <el-button v-authority="'BACK_MENU5_M12_B3'" type="danger" @click="deleteRow(scope.row.lrId)" size="mini" plain icon="el-icon-delete" />
                    </template>
                </el-table-column>
            </h-table>
        </box>

        <!-- 新增&&编辑框 -->
        <el-dialog :title="add_or_edit ? '新增' : '编辑'" :close-on-click-modal="false" :visible.sync="editBoxShow" :style="$popups.popups(0.5,0.45)" class="fromDialog" :model="mainObj" @open="open">
            <span class="formClass">
                <el-form label-width="100px" :model="mainObj" :rules="rules" ref="mainObj">
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="站点类型" prop="lrType" class="EL-Form-Item">
                            <el-input v-model="mainObj.lrType" placeholder="请输入" clearable="clearable"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="站点编号" prop="lrCode" class="EL-Form-Item">
                            <el-input v-model="mainObj.lrCode" placeholder="请输入" clearable="clearable"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="站点名称" prop="lrName" class="EL-Form-Item">
                            <el-input v-model="mainObj.lrName" placeholder="请输入" clearable="clearable"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="对应AGV编号" prop="lrAgvCode" class="EL-Form-Item">
                            <el-input v-model="mainObj.lrAgvCode" placeholder="请输入" clearable="clearable"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="状态" prop="occupyFlag" class="EL-Form-Item">
                            <el-select v-model="mainObj.occupyFlag" placeholder="请选择" clearable="clearable">
                                <el-option label="占用" value="true"></el-option>
                                <el-option label="空闲" value="false"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="产线编号" prop="lineCode" class="EL-Form-Item">
                            <el-select v-model="mainObj.lineCode" clearable="clearable" filterable placeholder="请选择">
                                <el-option v-for="(item, index) in lineList" :key="index" :value="item.lineCode" :label="item.lineCode"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="仓库类型" prop="lrPointType" class="EL-Form-Item">
                            <el-select v-model="mainObj.lrPointType" placeholder="请选择" clearable="clearable">
                                <el-option label="装配" value="10"></el-option>
                                <el-option label="外圈" value="20"></el-option>
                                <el-option label="内圈" value="30"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="库位类型" prop="lrStorage" class="EL-Form-Item">
                            <el-input v-model="mainObj.lrStorage" placeholder="请输入" clearable="clearable"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="容器类型" prop="lrCtnrTyp" class="EL-Form-Item">
                            <el-input v-model="mainObj.lrCtnrTyp" placeholder="请输入" clearable="clearable"> </el-input>
                        </el-form-item>
                    </el-col>
                </el-form>
            </span>
            <span slot="footer" class="dialog-footer footer-bottom">
                <el-button size="small" type="info" @click="editBoxShow = false">取 消</el-button>
                <el-button size="small" type="primary" v-if="add_or_edit" @click="add">新 增</el-button>
                <el-button size="small" type="primary" v-else @click="editRow">修 改</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "Warehouse",
        data() {
            return {
                headerCellStyle: () => {
                    return "background-color: #1f5cec";
                },
                form: {},
                rules: {
                    lrType: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    lrCode: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, {
                        max: 20,
                        message: "点位编号长度不能超过20位",
                    }],
                    lrAgvCode: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, {
                        max: 50,
                        message: "AGV呼叫站点长度不能超过50位",
                    }],
                    occupyFlag: [{
                        required: true,
                        message: "请选择",
                        trigger: "blur",
                    }, ],
                    prArea: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, {
                        max: 50,
                        message: "工作区长度不能超过50位",
                    }],
                    lineCode: [{
                        required: true,
                        message: "请选择",
                        trigger: "blur",
                    }, ],
                    prCntrTyp: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, {
                        max: 20,
                        message: "容器类型长度不能超过20位",
                    }],
                    // prBoxType: [{
                    //     required: true,
                    //     message: "请输入",
                    //     trigger: "blur",
                    // }, ],
                    // channelCode: [{
                    //     required: true,
                    //     message: "请输入",
                    //     trigger: "blur",
                    // }, ],
                    boxHeight: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, 
                    // {
                    //     max: 18,
                    //     message: "箱体高度长度不能超过18位",
                    // }
                    ],
                    prBoxType:[{
                        max: 10,
                        message: "箱体类型长度不能超过10位",
                    }],
                    channelCode:[{
                        max: 10,
                        message: "巷道编号长度不能超过10位",
                    }]
                },
                lineList:[],
                showRoleBox: true,
                add_or_edit: Boolean, //新增|编辑
                loading: 0, //加载中
                editBoxShow: false, //编辑框
                dialogFormVisible: false,
                formLabelWidth: "140px", // 对话框大小
                tableHeight: 0, //表格高度
                testValue: 1,
                mainObj: {},
                mainSearch: {
                    lrType: "",
                    lrCode: "",
                    occupyFlag: "",
                },
				tableTotal:0,
                mainData:{
                    data: [],
                    nowPage: 1,
                    pageSize: 20,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },   
                },
                fcode: localStorage.getItem("fcCode") || "",

                downloadLoading: false, //下载中

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,
            };
        },
        watch: {
            mainSearch: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.changeSysPointRouterAll(newVal);
                    }, 1000)
                },
                deep: true,
            },
        },
        methods: {
            /**
             * 打开修改窗口
             */
            updateRow(row){
                this.mainObj = JSON.parse(JSON.stringify(row));
                this.mainObj.occupyFlag = row.occupyFlag + "";
                this.add_or_edit = false;
                this.editBoxShow = true;
            },
            /**
             * 重置页码
             */
            changeSysPointRouterAll(newVal){
                this.mainData.nowPage = 1;
                this.getSysLineRouter(newVal);
            },
            //获取数据
            getSysLineRouter() {
                this.$http
                    .request({
                        url: "/api/sysLineRouter/getSysLineRouter",
                        method: "GET",
                        params: {
                            pageNum: this.mainData.nowPage,
                            pageSize: this.mainData.pageSize,
                            lrCode: this.mainSearch.lrCode || null,
                            lrType: this.mainSearch.lrType || null,
                            occupyFlag: this.mainSearch.occupyFlag || null
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.mainData.data = resp.data.list || [];
                            this.mainData.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },

            //获取所有产线信息
            getSysLineList(){
                this.$http
                    .request({
                        url: "/api/sysline/getSysLineList",
                        method: "GET",
                        params: {},
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.lineList = resp.data || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },

            //表单验证
            submitForm(formName) {
                let r = Boolean;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        r = true;
                    } else {
                        r = false;
                    }
                });
                return r;
            },
            //框打开
            open() {
                this.getSysLineList();
                if (this.add_or_edit) {
                    //新增
                    this.mainObj = JSON.parse(JSON.stringify({}));
                    this.$set(this.mainObj,'lrType','INPUT')
                } else {
                    this.getSysLineRouter();
                }
            },
            //新增
            add() {
                this.mainObj.fcCode = localStorage.getItem("fcCode");
                if (this.submitForm("mainObj")) {
                    this.$http
                        .request({
                            url: "/api/sysLineRouter/insertSysLineRouter",
                            method: "POST",
                            showLoading: true,
                            data: this.mainObj,
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "新增成功！",
                                    type: "success",
                                });
                                this.logRemarks = "warehouse：点位新增成功";
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: resp.message,
                                });
                                this.logRemarks = "warehouse：点位新增失败";
                            }
                            this.logContent = "prCode" + this.mainObj.prCode;
                            this.systemLog();
                            this.editBoxShow = false;
                            this.getSysLineRouter();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                }
            },
            //编辑
            editRow() {
                if (this.submitForm("mainObj")) {
                    this.$http
                        .request({
                            url: "/api/sysLineRouter/updateSysLineRouter",
                            method: "POST",
                            showLoading: true,
                            data: this.mainObj,
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "修改成功！",
                                    type: "success",
                                });
                                this.logRemarks = "warehouse：点位修改成功";
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: resp.message,
                                });
                                this.logRemarks = "warehouse：点位修改失败";
                            }
                            this.logContent = "prCode" + this.mainObj.prCode;
                            this.systemLog();
                            this.editBoxShow = false;
                            this.getSysLineRouter();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                }
            },
            //删除
            deleteRow(lrId) {
                console.log(lrId);
                this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
                        confirmButtonText: "删除",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/sysLineRouter/deleteSysLineRouter",
                                method: "DELETE",
                                showLoading: true,
                                params: {
                                    lrId: lrId,
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$notify({
                                        title: "成功",
                                        message: "删除成功！",
                                        type: "success",
                                    });
                                    this.logRemarks = "warehouse：产线站点删除成功";
                                } else {
                                    this.$notify.error({
                                        title: "失败",
                                        message: "删除失败",
                                    });
                                    this.logRemarks = "warehouse：产线站点删除失败";
                                }
                                this.logContent = "lrId" + lrId;
                                this.systemLog();
                                this.getSysLineRouter();
                            })
                            .catch((error) => {
                                this.$notify.error({
                                    title: "失败",
                                    message: "调用失败",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除",
                        });
                    });
            },

            //重置
            resetData() {
                this.mainSearch = {
                    lrCode: "",
                    lrType: "",
                    occupyFlag: "",
                }
            },

            //表格导出
            downLoadFile() {
                this.downloadLoading = true;
                var paramsObj = {
                    lrCode: this.mainSearch.lrCode || null,
                    lrType: this.mainSearch.lrType || null,
                    occupyFlag: this.mainSearch.occupyFlag || null,
                    pageNum: 1,
                    pageSize: 999999,
                }

                this.$http.request({
                    url: '/api/sysLineRouter/getSysLineRouter',
                    method: 'GET',
                    showLoading: true,
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                    list.forEach(function(c) {
                        if (c.occupyFlag == true) {
                            c['occupyFlag'] = '占用'
                        } else if (c.occupyFlag == false) {
                            c['occupyFlag'] = '空闲'
                        }

                        if (c.lrPointType == '10') {
                            c['lrPointType'] = '装配'
                        } else if (c.prGroup == '20') {
                            c['lrPointType'] = '锻圈'
                        }

                    })
                    const tHeader = ['站点编号', '站点名称',   '对应AGV编号', '站点类型','是否占用', '产线编号', '仓库类型', '库位信息', '容器类型', '创建时间']
                    const filterVal = ['lrCode', 'lrName',   'lrAgvCode', 'lrType','occupyFlag', 'lineCode', 'lrPointType', 'lrStorage', 'lrCtnrTyp', 'createTime']
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '产线站点数据'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "sys_warehouse：导出产线站点数据"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },


            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "通道主数据",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
        },
        activated(){
            /* 获取首页的数据 */
            this.getSysLineRouter();
            
        },
    };
</script>

<style scoped>
</style>